import { IconType } from "@common/declarations";
import * as React from "react";
import { type Courses } from "../../types";
import Item from "./ContentItem";

type Props = {
  activeLessonId: string | null;
  completeIconType?: IconType;
  items: Courses.ModuleLesson[];
  onLessonClick: (id: string) => void;
};
export default (props: Props) => (
  <>
    {props.items.map((item) => (
      <Item
        key={item.id}
        item={item}
        isActive={item.id === props.activeLessonId}
        onClick={props.onLessonClick}
        completeIconType={props.completeIconType}
      />
    ))}
  </>
);
